module.exports = __webpack_public_path__ + "static/media/logo-icon-shocked-bw.e6ab8ea9.svg";